// PANG-293 — Mecanismo "pular a tela de boas-vindas" do fluxo Panágora na Sala.
//
// O link gerado pelo botão da Sala traz `?destino=votacao` na rota /auth. Esse param se perde quando
// o login navega para "/", então persistimos a intenção em sessionStorage (sobrevive a refresh e ao
// caminho pós-aceite-de-termo). É uma flag one-shot: gravada no LinkUnico, consumida ao redirecionar
// para a urna em EventoIndex e limpa no logout por segurança.
//
// O frontend conhece apenas a intenção `destino=votacao`, não a origem "Sala" — a policy de quando
// pular mora no Manduá.

const STORAGE_KEY = 'origemDestinoVotacao';

// O sessionStorage pode estar bloqueado ou recusar gravação; a memória garante a flag até o reload.
let destinoEmMemoria = false;

export function marcaDestinoVotacao() {
    destinoEmMemoria = true;
    try {
        sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
        // sem storage, a flag segue só em memória
    }
}

export function temDestinoVotacao() {
    if (destinoEmMemoria) {
        return true;
    }
    try {
        return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
        return false;
    }
}

export function limpaDestinoVotacao() {
    destinoEmMemoria = false;
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
        // sem acesso ao storage, não há o que limpar nele
    }
}
